module.exports = __webpack_public_path__ + "static/media/L7.818142a2.jpg";